<template>
  <div id="app" :class="[hasHeader?'has-header':'', isIphoneX?'iphoneX':'', isIphone?'iphone':'', appChannel]">
    <navigate-header hasBack="true" :title="navigateTitle" v-if="hasHeader && !specialHeader" :navigateStyle="navigateStyle"/>
    <!--<keep-alive>&lt;!&ndash; keep-alive只能保留body的滚动状态&ndash;&gt;-->
      <!--<router-view v-if="$route.meta.keepAlive" class="router-view" :class="[hasHeader?'has-header':'', appChannel]" ref="routerView"></router-view>-->
    <!--</keep-alive>-->
    <!--<router-view v-if="!$route.meta.keepAlive" class="router-view" :class="[hasHeader?'has-header':'', appChannel]" ref="routerView"></router-view>-->
    <router-view class="router-view" :class="[hasHeader?'has-header':'', appChannel, isIphoneX?'iphoneX':'', isIphone?'iphone':'']" ref="routerView"></router-view>
    <toast ref="toast"></toast>
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import Vue from 'vue'
// config
// import APP from '@/config/app.config'
import ETC from '@/config/etc.config'
// components
import Toast from '@/components/cool.toast'
import Confirm from './components/cool.confirm'
import NavigateHeader from './components/cool.navigateHeader'
// utils
import Plugins from '@/utils/plugins'
// mixin
import FunMixin from '@/mixins/funMixin'
import ChannelMixin from '@/mixins/channelMixin'
// import Modal from '@/components/cool.modal'
// store
import {mapMutations} from 'vuex'

import eventBus from '@/utils/eventBus'

const SPECIAL_HEADERS = [
  'goodsDetail',
  'result',
  'applyDetail',
  'applyProgress'
]

export default {
  mixins: [
    FunMixin,
    ChannelMixin
  ],
  components: {
    Toast,
    Confirm,
    NavigateHeader
    // Modal
  },
  data () {
    return {
      specialHeader: false,
      isIphone: '',
      isIphoneX: ''
    }
  },
  methods: {
    storageInit() {
      // storage缓存
      if (this.$route.name !== 'goodsDetail') {
        let currentCard = localStorage.getItem('currentCard')
        let currentIssuer = localStorage.getItem('currentIssuer')
        let currentOrder = localStorage.getItem('currentOrder')
        let chooseBank = localStorage.getItem('chooseBank')
        currentCard && (this.setCurrentCard(JSON.parse(currentCard)))
        currentIssuer && (this.setCurrentIssuer(JSON.parse(currentIssuer)))
        currentOrder && (this.setCurrentOrder(JSON.parse(currentOrder)))
        chooseBank && (this.setChooseBank(JSON.parse(chooseBank)))
      }
      let newApplyInfo = localStorage.getItem('newApplyInfo')
      newApplyInfo && (this.setNewApplyInfo(JSON.parse(newApplyInfo)))
    },
    ...mapMutations([
      'setChooseBank',
      'setCurrentCard',
      'setCurrentIssuer',
      'setCurrentOrder',
      'setNewApplyInfo',
      'setUserLocation',
      'setGDTInfo'
    ])
  },
  // dynamically set transition based on route change
  watch: {
    '$route' (to, from) {
      this.setNavigateStyle(to.meta.navigateStyle)
      this.setNavigateTitle(to.meta.title)
      // Vue.prototype.navigateTitle = to.meta.title
      // Vue.prototype.navigateStyle = to.meta.navigateStyle
      this.specialHeader = SPECIAL_HEADERS.indexOf(to.name) > -1
    }
  },
  beforeCreate() {
    Vue.prototype.bus = {
      $refs: this.$refs
    }
    Vue.prototype.$eventBus = eventBus;
    // Vue.prototype.bus = this
    // Vue.prototype.toast = this.$refs.toast
  },
  mounted() {
  },
  async created() {
    console.log('app enter query:', this.$route.query, ' params:', this.$route.params)
    const enterP = Object.assign({}, this.$route.query, this.$route.params)
    // const enterP = Object.keys(this.$route.query).length === 0 ? (Object.keys(this.$route.params).length === 0 ? {} : this.$route.params) : this.$route.query
    Plugins.getSystemInfo()

    if (enterP.uid === '__UID__' /* || enterP.uid === 'XXXX' */) {
      enterP.uid = void 0
    }
    // 获取各种参数
    let uuid = enterP.userToken || enterP.uid || enterP.qz_gdt // 广告投放
    let channel = enterP.channel
    let lat = enterP.lat
    let lng = enterP.lng
    let entry = enterP.entry || '' // 目前只有广告 entry
    let recommend = enterP.recommend || '' // 目前只有招行推荐人
    try {
      uuid && JSON.parse(uuid) instanceof Array && (uuid = JSON.parse(uuid)[0])
      lat && JSON.parse(lat) instanceof Array && (lat = JSON.parse(lat)[0])
      lng && JSON.parse(lng) instanceof Array && (lng = JSON.parse(lng)[0])
    } catch (e) {
      // console.log('json parse err:', e)
    }
    if (uuid && uuid !== localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID)) {
      localStorage.setItem(ETC.LOCAL_STORAGE_KEY.UUID, uuid)
      localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN, '')
    }
    lat && this.setUserLocation({latitude: lat, longitude: lng})
    // 广点通广告 entry qz_gdt    其他渠道的entry
    localStorage.setItem(ETC.LOCAL_STORAGE_KEY.ENTRY, entry)
    enterP.qz_gdt && this.setGDTInfo({click_id: enterP.qz_gdt})
    // 定制发卡方
    enterP.issuer && sessionStorage.setItem(ETC.SESSION_STORAGE_KEY.CUSTOM_ISSUER, enterP.issuer)
    // 渠道
    if (channel && channel !== localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)) {
      localStorage.setItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL, channel)
    }
    Vue.prototype.appChannel = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)
    if (this.appChannel === 'zhaohang') {
      sessionStorage.setItem(ETC.SESSION_STORAGE_KEY.ZHAO_HANG_LOGIN, localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID) || '')
      recommend && (localStorage.setItem(ETC.LOCAL_STORAGE_KEY.ZHAO_HANG_RECOMMEND, recommend))
    }

    this.specialHeader = SPECIAL_HEADERS.indexOf(this.$route.name) > -1
    this.isIphoneX = await this.m_isIphoneX()
    this.isIphone = await this.m_isIOS()
    this.setNavigateStyle(this.$route.meta.navigateStyle)
    this.setNavigateTitle(this.$route.meta.title)
    // Vue.prototype.hasHeader =
    // Vue.prototype.navigateTitle = this.$route.meta.title
    // Vue.prototype.navigateStyle = this.$route.meta.navigateStyle
    this.storageInit()
    this.c_channelInit()
    console.log('appStartDefer resolve')
    Plugins.appStartDefer.resolve()
  }
}
</script>
<style lang="scss">
@import "style/app";

#app {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100vw;
  overflow-x: hidden;
  color: #333333;
  background-color: #fff;
  .router-view{
    min-height: 100vh;
    /*box-sizing: content-box;*/
  }
  &.has-header{
    .router-view{
      padding-top: 88px;
      /*min-height: calc(100vh - 88px);*/
    }
  }
  &.iphoneX{
    .router-view{
      padding-bottom: 34px;
    }
    .fixed-bottom{
      height: 34px;
    }
  }

  .cool-navigate-header{
    .right-btn{
      float: right;
      font-size: 28px;
      .iconfont{
        font-size: 38px;
      }
    }
  }
}

.long-phone-btn{
  height: 20px;
}
</style>
